<template>
  <div class="lg:w-80 xl:w-96 shrink-0">
    <div class="bg-white rounded-2xl shadow-md p-4">
      <h3 class="text-lg font-bold text-gray-900 mb-4">Historique</h3>
      <ClaimHistoricalChanges :claim="claim" />
    </div>

    <PlanSaleInformation class="mt-3" :claim="claim" :replacementHandlingType="replacementHandlingType" />
  </div>
</template>

<script>
import ClaimHistoricalChanges from "@/components/claim/details/information/ClaimHistoricalChanges.vue";
import PlanSaleInformation from "@/components/claim/details/information/PlanSaleInformation.vue";

export default {
  components: {
    ClaimHistoricalChanges,
    PlanSaleInformation,
  },

  props: {
    claim: {
      type: Object,
      required: true,
    },
    replacementHandlingType: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
